import { MsgSend, MsgExecuteContract } from "@goblinhunt/cosmes/client";

/**
 * Sends LUNC or CW20 tokens to all recipients in a single transaction.
 * 
 * @param {ConnectedWallet} wallet - connected wallet
 * @param {string} fromAddress - sender address
 * @param {Array<string>} recipients - array of holder addresses
 * @param {string} token - "uluna" or CW20 token contract address
 * @param {number} amount - amount to send to each recipient
 * @param {string} [txMemo] - optional transaction memo
 */
export async function sendTokens(
  wallet,
  fromAddress, 
  recipients,
  token,
  amount,
  decimals = 6,
  txMemo = "Sent via NFT.Lunc.Tools NFT Reward System"
) {
  console.log("sendTokens called with:", { token, amount, decimals, recipients: recipients.length });

  // always convert to smallest unit
  const microAmount = BigInt(Math.round(amount * 10 ** decimals)).toString();

  const messages = recipients.map(address => {
    if (token === "uluna") {
      return new MsgSend({
        fromAddress,
        toAddress: address,
        amount: [{ denom: "uluna", amount: microAmount }],
        funds: [],
      });
    } else {
      return new MsgExecuteContract({
        sender: fromAddress,
        contract: token,
        msg: { transfer: { recipient: address, amount: microAmount } },
        funds: [],
      });
    }
  });

  const tx = { msgs: messages, memo: txMemo };
  const fee = await wallet.estimateFee(tx, 2.1);
  const txHash = await wallet.broadcastTx(tx, fee);

  return txHash;
}
